module.exports = __webpack_public_path__ + "img/TV_clean_box17.47bf6a36.jpg";